import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("haccp_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function fileUrl(fileId) {
  const t = localStorage.getItem("haccp_token");
  return `${API}/files/${fileId}?auth=${t}`;
}

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/files/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { file_id, filename, content_type }
}

export function exportPdfUrl(params) {
  const t = localStorage.getItem("haccp_token");
  const q = new URLSearchParams({ ...params, auth: t }).toString();
  return `${API}/export/pdf?${q}`;
}
